import { render, staticRenderFns } from "./TableRowPercentNewPatientsOnSlit.vue?vue&type=template&id=a766862c&lang=pug&"
import script from "./TableRowPercentNewPatientsOnSlit.vue?vue&type=script&lang=js&"
export * from "./TableRowPercentNewPatientsOnSlit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a766862c')) {
      api.createRecord('a766862c', component.options)
    } else {
      api.reload('a766862c', component.options)
    }
    module.hot.accept("./TableRowPercentNewPatientsOnSlit.vue?vue&type=template&id=a766862c&lang=pug&", function () {
      api.rerender('a766862c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowPercentNewPatientsOnSlit.vue"
export default component.exports